Controller = App.loadClass 'core::Angular/Controller'

class exports.LoginController extends Controller
    constructor: (@scope, @transitions, $state, $modal, $http, $q, $stateParams, Routing, Session) ->
        super

        # We are authenticated. Route to the default state.
        if Session.get 'Authorization'
            return Routing.determineDestination($stateParams)

        @scope.branding = $stateParams.b
        pendingEmail = $stateParams.pending_email
        @scope.registration_token = $stateParams.registration_token

        $('#outer_messagewrapper').message_writer autoHide: false
        @scope.username = pendingEmail ? ''
        @scope.password ?= ''

        @scope.resetPassword = (email) =>
            newScope = @scope.$new()
            newScope.params = { email: email }

            dlg = $modal.open
                windowClass: 'small_dialog'
                templateUrl: 'backend/session-mgmt/forgot-password-layout'
                controller: 'Main.Controllers.ForgotPasswordController'
                scope: newScope

        if $stateParams.reset_email
            @scope.resetPassword($stateParams.reset_email)


        @scope.login = () =>
            $('#outer_messagewrapper').message_writer('info', 'Logging in...')
            $http.post "#{Config.get('api_url')}/auth",
                identifier: @scope.username
                password: @scope.password
                pendingEmail: pendingEmail
            .then (response) =>
                token = response.data.token

                Session.set 'Authorization', "Bearer #{token}"
                Session.set 'SafeLink', "Bearer #{token}"
                Session.set 'OriginalUser', "Bearer #{token}"
                Session.set 'AuthTime', new Date().getTime()

                # See what user id we are and register ourselves with the websocket connection
                $http.get "#{Config.get('api_url')}/me"
                .then (response) =>
                    Socket.whenopen () ->
                        Socket.socket?.send response.data.id
                    Raven?.setUserContext response.data

                $('#outer_messagewrapper').message_writer('success', 'Logged In')
                Routing.determineDestination($stateParams)
                return response
            .catch (err) =>
                if err.status is 403 and err.data.error is 'inactive'
                    message = 'Your account is inactive, therefore, you cannot login to MyFarms. If you believe this has happened in error, please contact support@myfarms.com.'
                else if err.status is 403
                    message = "It looks like your account hasn't been authenticated yet. Check your email for an authentication link or contact your advisor for help."
                else
                    message = 'Invalid Credentials'
                $('#outer_messagewrapper').message_writer('error', message)
                return $q.reject err
